module.exports = __webpack_public_path__ + "assets/img/grzl@2x.275d3e98.png";